module.exports = __webpack_public_path__ + "assets/img/017e-fj.svg";